import { basicMsg, valMsg } from "../../swal_msg";
import { protectedReq } from "../../../helpers/requestHelper";
import { USER_ADDRESS } from "../../../constants/user/user_constants";

export const myShippingAddresses = async() => {
    try {
        const resp = await protectedReq('account/shipping/list');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'server-err')
                valMsg('error', 'Direcciones de envío',
                'Ocurrió un incidente. Intente de nuevo, por favor');
        }
        return body;
    } catch (err) {
        valMsg('error', 'Direcciones de envío',
        'No se pueden mostrar sus direcciones');
        return { status: false };
    };
};

export const addShippingAddress = async(model) => {
    try {
        const { _id, ...address } = model;
        const resp = await protectedReq('account/shipping/save', address, 'POST');
        const body = await resp.json();
        if (body.status)
            basicMsg('Dirección de envío guardada');
        else {
            if (body.msg === 'not-saved')
                valMsg('warning', 'Dirección de envío',
                'No se guardó su dirección. Intente de nuevo, por favor');
            else if (body.msg === 'server-err')
                valMsg('error', 'Dirección de envío',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else valMsg('warning', 'Dirección de envío',
                'Dirección no guardada. Inténtelo de nuevo, por favor');
        }
        return body;
    } catch (err) {
        valMsg('error', 'Direcciones de envío',
        'No se pudo guardar su dirección');
        return { status: false };
    };
};

export const updShippingAddress = async(model) => {
    try {
        const resp = await protectedReq('account/shipping/update', model, 'PUT');
        const body = await resp.json();
        if (body.status)
            basicMsg('Dirección de envío actualizada');
        else {
            if (body.msg === 'not-saved')
                valMsg('warning', 'Dirección de envío',
                'No se actualizó su dirección. Intente de nuevo, por favor');
            else if (body.msg === 'server-err')
                valMsg('error', 'Dirección de envío',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else valMsg('warning', 'Dirección de envío',
                'Dirección no actualizada. Inténtelo de nuevo, por favor');
        }
        return body;
    } catch (err) {
        valMsg('error', 'Dirección de envío',
        'No se pudo actualizar su dirección');
        return { status: false };
    };
};

export const delShippingAddress = async(
    _id, setAddresses, setActiveAddress, closeForm, setAlertDelete
) => {
    try {
        const resp = await protectedReq('account/shipping/delete', { _id }, 'DELETE');
        const body = await resp.json();
        if (body.status) {
            const { address_id } = body.resp;
            if (address_id)
                setAddresses(
                    e => e.filter(u => u._id !== _id).map(
                        u => u._id === address_id ? { ...u, by_default: true } : u
                    )
                );
            else
                setAddresses(
                    e => e.filter(u =>u._id !== _id)
                );
            closeForm();
            setActiveAddress(USER_ADDRESS);
            setAlertDelete(true);
        } else {
            if (body.msg === 'not-deleted')
                valMsg('warning', 'Dirección de envío',
                'No se eliminó su dirección. Intente de nuevo, por favor');
            else if (body.msg === 'server-err')
                valMsg('error', 'Dirección de envío',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else valMsg('warning', 'Dirección de envío',
                'Dirección no eliminada. Inténtelo de nuevo, por favor');
        }
    } catch (err) {
        valMsg('error', 'Dirección de envío',
        'No se pudo eliminar su dirección');
    };
};

export const defaultShippingAddress = async(_id, setAddresses) => {
    try {
        const resp = await protectedReq('account/shipping/as-default', { _id }, 'PUT');
        const body = await resp.json();
        if (body.status)
            setAddresses(e => e.map(
                u => (u._id === _id) ?
                    { ...u, by_default: true }
                :
                    { ...u, by_default: false}
            ));
        else {
            if (body.msg === 'not-updated')
                basicMsg('Dirección de envío no actualizada');
            else if (body.msg === 'server-err')
                valMsg('error', 'Dirección de envío',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else valMsg('warning', 'Dirección de envío',
                'Dirección no actualizada. Inténtelo de nuevo, por favor');
        }
    } catch (err) {
        valMsg('error', 'Dirección de envío',
        'No se pudo actualizar su dirección');
    };
};